<div
  class="p-col-12"
  style="padding-top: 0"
  *ngIf="viewModel$ | async as viewModel"
>
  <div class="header-with-button" *ngIf="showHeader">
    <header class="p-my-2 estimates-header">
      <h2>Calculator</h2>
    </header>
    <button
      *ngIf="isDev"
      label="Reload Script"
      class="p-m-1"
      pButton
      icon="pi pi-code"
      outlined="true"
      pTooltip="Dev only (not visible to users)"
      (click)="store.dispatch(actions.reloadScriptButtonClicked())"
    ></button>

  </div>
  <div>
    <ng-container *ngIf="viewModel.scriptError">
      <div class="calculator-error">
        <i class="pi pi-exclamation-triangle"></i>
        <span>Calculator failed to load. {{ viewModel.scriptError }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!viewModel.scriptLoaded && !viewModel.scriptError">
      <p-skeleton
        *ngFor="let number of [0, 1, 2]"
        styleClass="p-mb-1"
        borderRadius="0.571rem"
        width="100%"
        height="3.2rem"
      ></p-skeleton>
    </ng-container>
    <div class="form-container p-fluid" *ngIf="viewModel.scriptLoaded && !viewModel.scriptError">
      <app-calculator-field
        *ngFor="
          let element of viewModel.elements;
          let i = index;
          trackBy: trackByKey
        "
        [formElement]="element"
      ></app-calculator-field>
    </div>
  </div>
</div>
